/* eslint-disable @typescript-eslint/explicit-member-accessibility */
export class Status {
    status: string
}
